import React from 'react'
import styled, { css, ThemeConsumer, ThemeProvider } from 'styled-components'
import { spacingUtils } from '@bootstrap-styled/css-utils'
import { appTheme, GlobalStyle } from './app.theme'
import { formatSpacing } from './functions'
import { hideVisually } from './mixins'

/**
 * custom Wrapper styled component to resolve a trouble about spacers,
 * also it's can to add another global style
 */
const AppThemeWrapper = styled.div`
    background: transparent;

    ${props =>
        props.theme['$grid-breakpoints'] &&
        props.theme['$spacers'] &&
        css`
            ${spacingUtils.getSpacingUtilities(
                props.theme['$grid-breakpoints'],
                formatSpacing(props.theme['$spacers'])
            )}
        `}

    .hidden-text {
        ${hideVisually()}
    }
`
AppThemeWrapper.defaultProps = {
    theme: appTheme
}

// type definition
export interface AppThemeProviderProps {
    theme: unknown // TODO: Poner la firma de tipo - DefaultTheme (Typescript) del tema actual de la aplicación
    injectGlobal: boolean
}

/**
 * custom Provider to pass app's theme
 */
class AppThemeProvider extends React.Component<AppThemeProviderProps> {
    public static defaultProps = {
        theme: appTheme,
        injectGlobal: false
    }

    render(): React.ReactNode {
        const { children, injectGlobal } = this.props

        return (
            <ThemeConsumer>
                {(theme = this.props.theme) => (
                    <ThemeProvider theme={theme}>
                        {injectGlobal && <GlobalStyle />}
                        <AppThemeWrapper>{children}</AppThemeWrapper>
                    </ThemeProvider>
                )}
            </ThemeConsumer>
        )
    }
}

export default AppThemeProvider
